if (!customElements.get('ly-main-cart-items-content-form-item-set')) {
    customElements.define('ly-main-cart-items-content-form-item-set', class extends HTMLElement {

        connectedCallback() {
            this.spinner = this.querySelector('.loading__spinner')

            this.links = [...this.querySelectorAll('a.cart-remove-link[href="#"]')]

            const script = this.querySelector('script[type="application/json"][data-installation-service-mapping]')
            this.installationServiceMapping = readJsonFromScript(script)

            this.links.forEach(link => {
                link.addEventListener('click', this.handleClick)
            })
        }

        disconnectedCallback() {
            this.links.forEach(link => {
                link.removeEventListener('click', this.handleClick)
            })
        }

        handleClick = async (evt) => {
            evt.preventDefault()

            const currLink = evt.currentTarget

            const ids = new Set([currLink.dataset.id])
            const urls = new Set([currLink.dataset.url])

            try {
                this.startLoading()

                // 如果是删除主产品，需要删除所有的二级和三级产品
                if (currLink.hasAttribute('data-primary')) {
                    this.links.forEach(link => {
                        urls.add(link.dataset.url)
                    })

                    for (const url of urls) {
                        await this.doFetch(url)
                    }

                    return
                }

                // 如果是删除的安装服务，正常删除
                if (currLink.hasAttribute('data-installation-service')) {
                    console.log(urls)
                    for (const url of urls) {
                        await this.doFetch(url)
                    }
                    return
                }

                // 如果是删除二级产品，需要跟随删除它的三级产品
                if (currLink.hasAttribute('data-secondary')) {
                    const secondaryItem = currLink.closest('.ly-main-cart-items-content-form-item-set-secondary')
                    if (secondaryItem) {
                        const thirdLinks = [...secondaryItem.querySelectorAll('.ly-main-cart-items-content-form-item-set-third-list .ly-main-cart-items-content-form-item-third-remove')]
                        thirdLinks.forEach(link => {
                            ids.add(link.dataset.id)
                            urls.add(link.dataset.url)
                        })
                    }
                }

                // 查找对应的安装服务
                if (this.installationServiceMapping) {
                    for (const id of ids) {
                        const serviceId = this.installationServiceMapping[id]
                        const link = this.links.find(link => link.dataset.id === serviceId)
                        if (link) {
                            urls.add(link.dataset.url)
                        }
                    }
                }

                for (const url of urls) {
                    await this.doFetch(url)
                }

            } catch (error) {
                this.stopLoading()
                console.error(error)
            } finally {
                window.location.reload()
            }
        }

        doFetch = async (url, retry = 3) => {
            try {
                await fetch(url)
            } catch (err) {
                if (retry > 0) {
                    console.warn(`请求失败，正在重试...（剩余 ${retry} 次）`, err)
                    return await this.doFetch(url, retry - 1)
                } else {
                    console.error("请求完全失败：", err)
                    throw err
                }
            }
        }

        startLoading = () => this.spinner.classList.remove('hidden')

        stopLoading = () => this.spinner.classList.add('hidden')
    })
}